import type { BulkImportItem, ParameterDefinition, ScheduleConfig } from '../api/dataSources';

export class ImportNormalizationError extends Error {}

interface IttihatRawParam {
  name?: unknown;
  type?: unknown;
  required?: unknown;
  default?: unknown;
}

export function normalizeImportItem(
  raw: Record<string, unknown>,
  index: number,
): BulkImportItem {
  const name = String(raw.name ?? '');
  const sourceName = String(raw.sourceName ?? raw.source_name ?? raw.body ?? '');
  if (!sourceName) {
    throw new ImportNormalizationError(`#${index}: sourceName eksik`);
  }

  return {
    name: name || sourceName,
    sourceName,
    sourceType: typeof raw.sourceType === 'string' ? raw.sourceType : undefined,
    parameters: normalizeParameters(raw),
    schedule:
      raw.schedule && typeof raw.schedule === 'object' && !Array.isArray(raw.schedule)
        ? (raw.schedule as ScheduleConfig)
        : undefined,
  };
}

function normalizeParameters(
  raw: Record<string, unknown>,
): Record<string, ParameterDefinition> | undefined {
  if (raw.parameters && typeof raw.parameters === 'object' && !Array.isArray(raw.parameters)) {
    return raw.parameters as Record<string, ParameterDefinition>;
  }
  if (Array.isArray(raw.params)) {
    const dict: Record<string, ParameterDefinition> = {};
    for (const p of raw.params as IttihatRawParam[]) {
      if (!p || typeof p.name !== 'string' || p.name.length === 0) continue;
      dict[p.name] = {
        type: typeof p.type === 'string' ? p.type : 'string',
        defaultValue: typeof p.default === 'string' ? p.default : undefined,
        required: typeof p.required === 'boolean' ? p.required : true,
      };
    }
    return Object.keys(dict).length > 0 ? dict : undefined;
  }
  return undefined;
}
